package prescription.containers

import com.jingfangpai.api.clients.PrescriptionApiClient
import com.jingfangpai.prescription.model.PrescriptionDetail
import prescription.components.PrescriptionEdit
import react.*
import react.dom.div
import setTitle

external interface PrescriptionEditPageProps : RProps {
    var id: String
}

data class PrescriptionEditPageContextData(
    var save: (prescription: com.jingfangpai.common.orm.mapping.Prescription, okCallback: (result: com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Prescription>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var getDetail: (id: String, okCallback: (result: com.jingfangpai.common.data.response.ApiResponse<PrescriptionDetail>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit
)

val PrescriptionEditPageContext = createContext(PrescriptionEditPageContextData(PrescriptionApiClient::save, PrescriptionApiClient::getDetail))

val PrescriptionEditPageProvider = functionalComponent<PrescriptionEditPageProps> { props ->

    setTitle("方剂编辑")

    useEffectOnce { }

    PrescriptionEditPageContext.Provider(PrescriptionEditPageContextData(PrescriptionApiClient::save, PrescriptionApiClient::getDetail)) {
        div("PrescriptionEditPage-page") {
            child(PrescriptionEdit) {
                attrs {
                    id = props.id
                }
            }
        }
    }
}
